import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-[24px] font-bold text-[#16161d] text-left m-0"
}
const _hoisted_2 = {
  key: 2,
  class: "flex items-start gap-2 rounded-lg border border-negative/40 bg-negative/5 px-3 py-2.5 text-left text-sm text-negative",
  "data-testid": "policy-registration-lock-banner",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "🔒", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Você não tem permissão para editar regras de registro e auditoria."),
  /*#__PURE__*/_createTextVNode(" As seções abaixo estão em modo leitura. Peça a um administrador da empresa a permissão "),
  /*#__PURE__*/_createElementVNode("i", null, "“Editar registro e auditoria da política”"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "flex-1 overflow-y-auto pr-8 pb-3" }
const _hoisted_7 = {
  class: "mb-3",
  "data-testid": "create-schedule-policy-nome-input"
}
const _hoisted_8 = {
  class: "flex flex-wrap items-start gap-4 mb-2 mt-4",
  "data-testid": "policy-section-identification"
}
const _hoisted_9 = {
  class: "w-full sm:w-auto min-h-[56px]",
  "data-testid": "create-schedule-policy-vigencia-inicio-input"
}
const _hoisted_10 = { class: "w-full sm:w-auto min-h-[56px]" }
const _hoisted_11 = {
  class: "flex items-center gap-2 h-[48px] w-full sm:w-auto",
  "data-testid": "create-schedule-policy-vigencia-indeterminado-checkbox"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-medium text-gray-700 whitespace-nowrap" }, " Fim de vigência indeterminado ", -1)
const _hoisted_13 = {
  class: "flex flex-wrap gap-4",
  "data-testid": "create-schedule-policy-modalidade-select"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-neutral50 font-bold text-left text-md mb-1 mt-4 flex items-center gap-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Verificações obrigatórias", -1)
const _hoisted_17 = {
  key: 0,
  class: "rounded-full bg-primary5 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-primary40",
  "data-testid": "policy-check-inherited-badge"
}
const _hoisted_18 = {
  key: 0,
  class: "text-xs text-neutral50 text-left m-0 mb-3",
  "data-testid": "policy-check-inherited-help"
}
const _hoisted_19 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_20 = { class: "flex flex-wrap gap-4 items-stretch" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "flex-1 flex items-center" }
const _hoisted_23 = {
  class: "m-0 mt-1 text-[11px] font-bold text-neutral50 text-left",
  "data-testid": "policy-check-externos-disabled-hint"
}
const _hoisted_24 = { class: "flex flex-col min-w-[240px] flex-1 border border-gray-200 rounded-lg px-4 py-3" }
const _hoisted_25 = { class: "flex-1 flex items-center" }
const _hoisted_26 = {
  key: 0,
  class: "m-0 mt-1 text-[11px] font-bold text-primary40 text-left",
  "data-testid": "policy-check-nosso-time-inherited-tag"
}
const _hoisted_27 = {
  key: 1,
  class: "m-0 mt-1 text-[11px] font-bold text-alert text-left",
  "data-testid": "policy-check-nosso-time-changed-tag"
}
const _hoisted_28 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_29 = {
  key: 0,
  class: "mt-4 flex items-start gap-2 rounded-lg border border-alert/40 bg-alert/10 px-3 py-2.5 text-left text-sm text-alert",
  "data-testid": "policy-check-modality-warning",
  role: "alert"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "⚠️", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", { class: "block" }, "O check no app deixa de ser exigido nesta escala."),
  /*#__PURE__*/_createTextVNode(" Nesta modalidade o médico não registra pelo app: ao salvar, o botão de check-in some para todos os plantões a partir da vigência. O registro passa a chegar pela folha ou pelo sistema externo. ")
], -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "mt-4 flex items-start gap-2 rounded-lg border border-[#E3CE7C] bg-[#FBF3D3] px-3 py-2.5 text-left text-sm text-[#5C4700]",
  "data-testid": "policy-check-disable-warning",
  role: "alert"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "⚠️", -1)
const _hoisted_35 = { class: "block" }
const _hoisted_36 = { class: "mt-2 flex items-start gap-2 text-xs font-bold" }
const _hoisted_37 = ["checked"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "Entendi que o check-in deixa de ser exigido", -1)
const _hoisted_39 = {
  key: 2,
  class: "mt-6 mb-4"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral50 font-bold text-left text-md mb-3" }, "Tolerâncias de registro", -1)
const _hoisted_41 = { class: "flex flex-wrap gap-4 w-full" }
const _hoisted_42 = {
  class: "mt-6 mb-4",
  "data-testid": "policy-section-audit"
}
const _hoisted_43 = { "data-testid": "policy-audit-section" }
const _hoisted_44 = { class: "text-neutral50 font-bold text-left text-md mb-3 flex items-center gap-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "Auditoria", -1)
const _hoisted_46 = {
  key: 0,
  class: "rounded-full border border-negative/40 bg-negative/10 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-negative",
  "data-testid": "policy-section-audit-lock"
}
const _hoisted_47 = ["inert"]
const _hoisted_48 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_49 = {
  class: "text-xs text-neutral50 m-0",
  "data-testid": "policy-auto-approval-criteria"
}
const _hoisted_50 = {
  key: 0,
  class: "w-full sm:w-[320px]"
}
const _hoisted_51 = { class: "text-xs text-neutral50 text-left m-0" }
const _hoisted_52 = {
  class: "rounded-lg border border-primary20 bg-primary5/40 px-4 pb-1 pt-3 text-left",
  "data-testid": "policy-audit-deadline"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-1 text-sm font-bold text-textPrimary" }, "Auditoria do registro", -1)
const _hoisted_54 = { class: "m-0 mb-3 text-xs text-neutral50" }
const _hoisted_55 = { class: "flex w-full flex-wrap gap-4" }
const _hoisted_56 = {
  key: 0,
  class: "m-0 mb-3 text-xs text-primary30",
  "data-testid": "policy-audit-deadline-preview"
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "flex flex-wrap gap-4 w-full mt-4" }
const _hoisted_59 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary50 font-bold text-left mb-4 text-md" }, "Folhas da escala", -1)
const _hoisted_61 = { class: "flex flex-wrap items-start gap-4 mb-2" }
const _hoisted_62 = {
  key: 0,
  class: "text-red-600 text-xs mt-1"
}
const _hoisted_63 = { class: "mt-4" }
const _hoisted_64 = {
  key: 0,
  class: "text-primary50 font-bold text-left mb-4 text-md"
}
const _hoisted_65 = { class: "flex-1 text-left" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary50" }, "Nome do modelo", -1)
const _hoisted_67 = { class: "text-sm text-primary50" }
const _hoisted_68 = {
  key: 1,
  class: "text-red-600 text-xs mt-1"
}
const _hoisted_69 = {
  class: "mt-6",
  "data-testid": "policy-section-activity-records"
}
const _hoisted_70 = {
  key: 0,
  class: "mr-2 rounded-full border border-negative/40 bg-negative/10 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-negative",
  "data-testid": "policy-section-activity-records-lock"
}
const _hoisted_71 = { class: "flex flex-col gap-4 text-left" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral50 m-0 mt-1" }, " Desligado, o hub “Enviar registro” da vaga só oferece Registro de Plantão e nenhuma solicitação de atividade é criada nesta escala. ", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-neutral50 m-0" }, "Tipos aceitos nesta escala", -1)
const _hoisted_74 = {
  class: "text-xs text-neutral50 m-0",
  "data-testid": "policy-activity-records-summary"
}
const _hoisted_75 = { class: "mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-6" }
const _hoisted_76 = {
  key: 0,
  class: "text-red-600 text-xs mt-1 m-0",
  "data-testid": "policy-activity-types-error"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral50 m-0 mt-1" }, " Desmarcar um tipo não invalida registros já enviados com ele. “Ajuste administrativo” não é configurável por escala: só a auditoria o oferece, nunca o hub do escalista. ", -1)
const _hoisted_78 = {
  class: "mt-4",
  "data-testid": "policy-section-activity-request"
}
const _hoisted_79 = {
  class: "mt-4",
  "data-testid": "policy-section-source-precedence"
}
const _hoisted_80 = {
  key: 0,
  class: "mr-2 rounded-full border border-negative/40 bg-negative/10 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-negative",
  "data-testid": "policy-section-source-precedence-lock"
}
const _hoisted_81 = {
  key: 3,
  class: "mt-4",
  "data-testid": "policy-section-payment-source-acceptance"
}
const _hoisted_82 = {
  key: 0,
  class: "mr-2 rounded-full border border-negative/40 bg-negative/10 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-negative",
  "data-testid": "policy-section-payment-source-acceptance-lock"
}
const _hoisted_83 = {
  key: 4,
  class: "mt-4",
  "data-testid": "policy-section-post-station-gate"
}
const _hoisted_84 = {
  key: 0,
  class: "mr-2 rounded-full border border-negative/40 bg-negative/10 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-negative",
  "data-testid": "policy-section-post-station-gate-lock"
}
const _hoisted_85 = { class: "flex flex-col gap-3 text-left" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral50 m-0 mt-1" }, " Desligado, o estado do Registro de Plantão aparece apenas como informação na tela de pós-plantão. Ligado, o pós-plantão não pode ser aprovado enquanto houver plantão fora do estado “Registro OK”. ", -1)
const _hoisted_87 = {
  class: "w-full text-left text-xs text-neutral50",
  "data-testid": "policy-post-station-gate-states"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-1 pr-3 font-bold" }, "Estado"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-1 pr-3 font-bold" }, "Significado"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-1 font-bold" }, "Com o bloqueio ligado")
  ])
], -1)
const _hoisted_89 = { class: "py-1 pr-3 font-bold whitespace-nowrap" }
const _hoisted_90 = { class: "py-1 pr-3" }
const _hoisted_91 = { class: "py-1 whitespace-nowrap" }
const _hoisted_92 = {
  key: 5,
  class: "text-red-600 text-sm mt-2"
}
const _hoisted_93 = {
  key: 3,
  class: "flex flex-wrap items-center gap-3 rounded-lg border border-alert/40 bg-alert/10 px-3 py-2.5 text-left text-sm",
  "data-testid": "policy-activity-records-disable-confirm"
}
const _hoisted_94 = { class: "ml-auto flex gap-2" }
const _hoisted_95 = {
  key: 4,
  class: "flex justify-end mt-2 gap-4 border-t pt-4 shrink-0 bg-white"
}

import { ref, computed, watch, toRef } from 'vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { mdiCalendar, mdiTrashCanOutline, mdiPencilOutline, mdiPlus } from '@mdi/js'
import { DatePicker } from 'v-calendar'
import { useCreateScheduleStore } from '@/pinia-store/useCreateScheduleStore'
import { useDsAttendanceStore } from '@/pinia-store/useDsAttendanceStore'
import { step3Schema } from './schemas'

import EditableHeader from '@/components/designSystem/Inputs/EditableHeader.vue'
import OptionSelect from '@/components/designSystem/Select/OptionSelect.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import SheetTemplateModal from '@/components/designSystem/modals/SheetTemplateModal.vue'
import SegmentedControl from '@/components/designSystem/Inputs/SegmentedControl.vue'
import PermanenceToggleField from './PermanenceToggleField.vue'
import CollapsibleSection from '@/modules/company/Dashboard/components/CollapsibleSection.vue'
import SourcePrecedenceList from './SourcePrecedenceList.vue'
import ActivityRequestSection from './ActivityRequestSection.vue'
import ScheduleStepHeading from './ScheduleStepHeading.vue'
import { DEFAULT_SOURCE_PRECEDENCE, sanitizeSourcePrecedence } from './sourcePrecedence'
import PaymentSourceAcceptanceMatrix from './PaymentSourceAcceptanceMatrix.vue'
import {
  materializePaymentSourceAcceptance,
  modalitiesWithoutSource,
  paymentSourceAcceptanceForSave,
  type PaymentSourceAcceptanceMatrix as PaymentSourceAcceptanceMatrixValue
} from './paymentSourceAcceptance'
import type { PaymentSourceAcceptance } from '@/types/payment-eligibility.types'
import {
  AUDIT_DEADLINE_HELP,
  buildAuditDeadlinePreview,
  normalizeAuditDeadlineHours
} from './auditDeadline'
import {
  DEFAULT_CHECK_METHOD,
  formatVigencyDate,
  SCHEDULE_DEFAULT_CHECK_FLAGS,
  type CurrentCheckRequirement,
  type ScheduleCheckFlags
} from '@/utils/registrationCheck'
import { useRegistrationPolicyPermissions } from '@/modules/company/Policy/composables/useRegistrationPolicyPermissions'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

import { dayOptions } from '@/modules/company/Dashboard/modals/utils/data'
import {
  ActivityType,
  ACTIVITY_TYPE_LABELS,
  CheckMethod,
  DSAttendanceMonitoringType,
  DSAttendanceDeadlineCalculationType,
  DSAttendanceRuleRecurrence,
  DSATTENDANCE_MONITORING_TYPE_OPTIONS,
  DSATTENDANCE_DEADLINE_CALCULATION_OPTIONS,
  DSATTENDANCE_RECURRENCE_OPTIONS,
  CHECK_METHOD_OPTIONS,
  hasRulesAndTemplates,
  NOT_OUR_TEAM_CHECK_DISABLED_REASON
} from '@/constants/ds-attendance.constants'
import type { EffectiveSourceKind } from '@/constants/ds-attendance.constants'
import { SCHEDULE_SECTION_LABELS } from '@/constants/schedule-sections.constants'
import {
  AUTO_APPROVAL_OPTIONS,
  buildAutoApprovalCriteriaText,
  DEFAULT_AUTO_APPROVAL,
  DEFAULT_MANUAL_REVIEW_SAMPLE_RATE,
  DEFAULT_SHEET_CONFERENCE_BY,
  DSAttendanceAutoApproval,
  DSAttendanceSheetConferenceBy,
  MANUAL_REVIEW_SAMPLE_RATE_HELP,
  normalizeManualReviewSampleRate,
  SHEET_CONFERENCE_BY_HELP,
  SHEET_CONFERENCE_BY_OPTIONS
} from '@/constants/ds-attendance-auto-approval.constants'

import type {
  DSAttendancePolicyData,
  DSAttendancePolicyRule,
  DSAttendanceSheetTemplate
} from '@/types/ds-attendance.types'

import { ValidationError } from 'yup'
import { parseLocalDate } from '@/utils/date'
import { useToast } from 'vue-toastification'
import { useScheduleMaxDate } from '@/hooks/useScheduleMaxDate'
import RegistrationBlockImpactNotice from '@/modules/company/PostStation/components/RegistrationBlockImpactNotice.vue'
import { REGISTRATION_GATE_SETTING_NAME } from '@/modules/company/PostStation/constants'

/**
 * Rótulo do toggle do gate. O nome do ajuste vem da MESMA constante que o painel
 * de pós-plantão cita nos seus banners ("… está ligado nesta escala"): se as duas
 * telas divergirem, o gestor não reconhece na política o ajuste que a auditoria
 * culpa pelo bloqueio.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendancePolicy',
  props: {
    initialData: {},
    fullWidthModal: { type: Boolean },
    createSchedule: { type: Boolean },
    availableShifts: {},
    scheduleEndDate: {},
    canEditRegistrationSection: { type: Boolean, default: undefined },
    openActivityRecords: {},
    scheduleId: {},
    inheritedCheckFlags: {},
    currentCheckRequirement: {}
  },
  emits: ["save", "cancel"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;

const POST_STATION_GATE_LABEL = `${REGISTRATION_GATE_SETTING_NAME} para aprovar o pós-plantão`

/** Tabela estado × efeito de M4, seção "Pós-plantão" (espelha a §7.2b do spec). */
const POST_STATION_GATE_STATES = [
  {
    label: 'Registro OK',
    meaning: 'As duas pernas têm horário efetivo de uma fonte aceita.',
    effect: 'Libera a aprovação'
  },
  {
    label: 'Parcial',
    meaning: 'Só uma perna resolvida (ex.: check-in do app, sem check-out).',
    effect: 'Bloqueia'
  },
  {
    label: 'Pendente',
    meaning: 'Existe registro aguardando auditoria ou solicitação aberta.',
    effect: 'Bloqueia'
  },
  {
    label: 'Sem registro',
    meaning: 'Nenhum registro em nenhum canal e nenhuma solicitação aberta.',
    effect: 'Bloqueia'
  }
] as const



/**
 * Recorte do aviso ⑥: "N plantões DESTE MÊS", como a spec §7.2b escreve. Um
 * período configurável aqui seria mais um campo para o gestor entender antes de
 * responder a pergunta que ele veio responder (ligar ou não o gate).
 */
const blockImpactRange = computed(() => {
  const now = new Date()
  const pad = (value: number) => String(value).padStart(2, '0')
  const iso = (date: Date) =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
  return {
    from: iso(new Date(now.getFullYear(), now.getMonth(), 1)),
    to: iso(new Date(now.getFullYear(), now.getMonth() + 1, 0))
  }
})



const store = useCreateScheduleStore()
const dsAttendanceStore = useDsAttendanceStore()
const { flags } = useFeatureFlags()
const errors = ref<Record<string, string>>({})
const toast = useToast()

const { scheduleMaxDate } = useScheduleMaxDate(toRef(props, 'scheduleEndDate'))

const policyId = ref<string | number | undefined>(undefined)
const policyName = ref('')
const startDate = ref<Date | null>(null)
const endDate = ref<Date | null>(null)
const isIndeterminate = ref(false)
const monitoringType = ref<DSAttendanceMonitoringType>(DSAttendanceMonitoringType.MINHA_ESCALA_APP)
const externalApp = ref<string | null>(null)
const requiredCheckOurTeam = ref<boolean>(false)
const requiredCheckNotOurTeam = ref<boolean>(false)
const checkMethodOurTeam = ref<CheckMethod | null>(null)
const checkMethodNotOurTeam = ref<CheckMethod | null>(null)
const autoPermanenceOurTeam = ref<boolean>(true)
const autoPermanenceNotOurTeam = ref<boolean>(true)
const checkinLateToleranceMinutes = ref<number | null>(null)
const checkoutEarlyToleranceMinutes = ref<number | null>(null)
const submissionDeadlineHours = ref<number | null>(null)
const deadlineCalculationType = ref<DSAttendanceDeadlineCalculationType | null>(null)
/** Prazo de auditoria (§7.4). `string` porque `v-model.number` limpo devolve `''`. */
const auditDeadlineHours = ref<number | string | null>(null)
const auditDeadlineCalculationType = ref<DSAttendanceDeadlineCalculationType | null>(null)
const auditDeadlinePreview = computed(() =>
  buildAuditDeadlinePreview(normalizeAuditDeadlineHours(auditDeadlineHours.value))
)

/** Seção "Auditoria" (§6.1) — nasce nos padrões do spec, não em `null`. */
const sheetConferenceBy = ref<DSAttendanceSheetConferenceBy>(DEFAULT_SHEET_CONFERENCE_BY)
const autoApproval = ref<DSAttendanceAutoApproval>(DEFAULT_AUTO_APPROVAL)
/**
 * `number | string` não é frouxidão: `v-model.number` num `v-text-field` limpo devolve string
 * vazia, e é `normalizeManualReviewSampleRate` que traduz isso para 0 na hora de montar o
 * payload — o tipo aqui só reconhece o que o campo realmente devolve.
 */
const manualReviewSampleRate = ref<number | string>(DEFAULT_MANUAL_REVIEW_SAMPLE_RATE)

/* -------------------------------------------------------------------------
 * F2 (§1.5 / §8.4) — Registro de Atividade e precedência das fontes
 * ------------------------------------------------------------------------- */

/**
 * `ADMIN_ADJUSTMENT` fica FORA da lista por escala (Q4/Q10): o ajuste administrativo é
 * ofertado só dentro da auditoria, nunca no hub do escalista. Deixá-lo configurável aqui
 * tiraria o dente da regra — bastaria marcá-lo para reabrir a edição manual por fora.
 */
const SELECTABLE_ACTIVITY_TYPES: ActivityType[] = Object.values(ActivityType).filter(
  (type) => type !== ActivityType.ADMIN_ADJUSTMENT
)

/** `acceptedActivityTypes` nulo no backend significa "todos os configuráveis". */
const DEFAULT_ACCEPTED_ACTIVITY_TYPES: ActivityType[] = [...SELECTABLE_ACTIVITY_TYPES]

/** Default OFF (§1.5): ligar o Registro de Atividade é o rollout, escala a escala. */
const activityRecordsEnabled = ref<boolean>(false)
const acceptedActivityTypes = ref<ActivityType[]>([...DEFAULT_ACCEPTED_ACTIVITY_TYPES])
const sourcePrecedence = ref<EffectiveSourceKind[]>(sanitizeSourcePrecedence(null))
/**
 * As duas listas COMO O BACKEND DEVOLVEU (`null` = "esta escala não customizou"). A tela
 * mostra o default materializado (6 tipos, ordem de fábrica), mas o save devolve o valor
 * cru enquanto o usuário não mexer: o gate de `attendance_registration_configuring` compara
 * o payload com o que está gravado, e `null` → lista default contava como alteração da
 * seção protegida — um Editor Intermediário tomava 403 salvando só a tolerância (A1/1.04).
 */
const loadedAcceptedActivityTypes = ref<ActivityType[] | null>(null)
const loadedSourcePrecedence = ref<EffectiveSourceKind[] | null>(null)

/** `null`/vazio ou só tipos desconhecidos → todos os configuráveis, na ordem do catálogo. */
const normalizeAcceptedActivityTypes = (raw?: ActivityType[] | null): ActivityType[] => {
  const accepted = raw?.filter((type) => SELECTABLE_ACTIVITY_TYPES.includes(type))
  return accepted?.length
    ? SELECTABLE_ACTIVITY_TYPES.filter((type) => accepted.includes(type))
    : [...DEFAULT_ACCEPTED_ACTIVITY_TYPES]
}

const sameList = (a: readonly string[], b: readonly string[]) =>
  a.length === b.length && a.every((item, index) => item === b[index])

/** Lista gravada que o backend aceitaria de volta: não vazia, sem repetição, só valores do catálogo. */
const isValidStoredList = <T extends string>(raw: T[] | null, catalog: readonly T[]): raw is T[] =>
  raw !== null &&
  raw.length > 0 &&
  new Set(raw).size === raw.length &&
  raw.every((item) => catalog.includes(item))

/**
 * O que vai no payload: o valor cru enquanto a tela ainda mostra o que foi carregado
 * (`null` continua `null`), senão a lista da tela. Valor cru inválido (dado legado —
 * lista vazia, repetida ou fora do catálogo) também vira a lista da tela: devolvê-lo
 * reprovaria na validação e travaria o save inteiro sem o usuário ter tocado em nada.
 */
const acceptedActivityTypesForSave = (): ActivityType[] | null => {
  const raw = loadedAcceptedActivityTypes.value
  const untouched = sameList(acceptedActivityTypes.value, normalizeAcceptedActivityTypes(raw))
  if (!untouched) return [...acceptedActivityTypes.value]
  if (raw === null) return null
  return isValidStoredList(raw, Object.values(ActivityType))
    ? raw
    : [...acceptedActivityTypes.value]
}

const sourcePrecedenceForSave = (): EffectiveSourceKind[] | null => {
  const raw = loadedSourcePrecedence.value
  const untouched = sameList(sourcePrecedence.value, sanitizeSourcePrecedence(raw))
  if (!untouched) return [...sourcePrecedence.value]
  if (raw === null) return null
  return isValidStoredList(raw, DEFAULT_SOURCE_PRECEDENCE) ? raw : [...sourcePrecedence.value]
}
/**
 * F3 (§1.5 / M4) — prazos da solicitação automática, por canal. `null` = "usar o default
 * do produto" (a tela só mostra o default no placeholder, nunca o materializa) e `0` =
 * canal desligado. Nascem em `null` para que uma política anterior à F3 não passe a
 * gravar um prazo que ninguém escolheu.
 */
const requestAfterCheckoutHoursApp = ref<number | null>(null)
const requestAfterDaysSheet = ref<number | null>(null)
const requestAfterHoursExternal = ref<number | null>(null)

/** Q18 — janela de envio (spec 2026-09-25 §2.4). `null` = padrão do produto. */
const activityRequestSendWindowHoursApp = ref<number | null>(null)
const activityRequestSendWindowDaysSheet = ref<number | null>(null)

/**
 * F4 (§7.2b / M4, seção "Pós-plantão") — com `true`, o domínio "Registro de
 * Plantão" deixa de ser informativo e passa a barrar a aprovação do pós-plantão.
 *
 * A tela NÃO escolhe o valor inicial: políticas existentes nascem com o gate
 * ligado pelo backfill da migration da F4 e o default de política nova é decisão
 * do dono do produto, materializada numa constante do backend. Aqui só se mostra
 * o que veio no GET (ver `loadPostStationGateField`).
 */
const postStationBlockOnRegistration = ref<boolean>(false)

/**
 * A política carregada trouxe o campo? `null` = nenhuma política carregada
 * ainda (política NOVA). Numa política existente, a PRESENÇA do campo na
 * resposta é a única prova de que o backend da F4 está no ar.
 */
const loadedPolicyHasGate = ref<boolean | null>(null)

/**
 * Tolerância a backend anterior à F4: sem a prova acima, a seção não aparece e o
 * campo não entra no payload. Numa política nova não há resposta que prove nada,
 * e o fallback é a mesma feature detection que governa o cadeado da Q31 — o
 * backend do pacote de registro sobe inteiro, não campo a campo.
 */
const hasPostStationGate = computed(
  () => loadedPolicyHasGate.value ?? dsAttendanceStore.isRegistrationBackendAvailable
)

/* -------------------------------------------------------------------------
 * Frente B (spec antecipe-registration §6, Q15/Q26) — fontes aceitas para Antecipe/À vista
 * ------------------------------------------------------------------------- */

const paymentSourceAcceptance = ref<PaymentSourceAcceptanceMatrixValue>(
  materializePaymentSourceAcceptance(null)
)
/** Como o backend devolveu (`null` = default). É o que volta no save enquanto ninguém mexe. */
const loadedPaymentSourceAcceptance = ref<PaymentSourceAcceptance | null>(null)
/** `null` = política nova; senão, a PRESENÇA da chave no GET prova o backend da frente B. */
const loadedPolicyHasAcceptance = ref<boolean | null>(null)

const hasPaymentSourceAcceptance = computed(
  () =>
    flags.enabledPaymentEligibility &&
    (loadedPolicyHasAcceptance.value ?? dsAttendanceStore.isRegistrationBackendAvailable)
)

const missingAcceptanceModalities = computed(() =>
  modalitiesWithoutSource(paymentSourceAcceptance.value)
)

/** Seção na tela com alguma modalidade sem fonte: trava o salvar (a API responderia 400). */
const isPaymentSourceAcceptanceIncomplete = computed(
  () => hasPaymentSourceAcceptance.value && missingAcceptanceModalities.value.length > 0
)

const REQUEST_DELAY_REFS = {
  requestAfterCheckoutHoursApp,
  requestAfterDaysSheet,
  requestAfterHoursExternal,
  activityRequestSendWindowHoursApp,
  activityRequestSendWindowDaysSheet
} as const

const setRequestDelay = (field: keyof typeof REQUEST_DELAY_REFS, value: number | null) => {
  REQUEST_DELAY_REFS[field].value = value
  delete errors.value[field]
}

/** Valor com que a política foi carregada — o aviso ① só vale para quem DESLIGA. */
const initialActivityRecordsEnabled = ref<boolean>(false)
const pendingDisableConfirmation = ref(false)

// Nome diferente do da prop de propósito: a prop é o valor que a aba já calculou e
// tem precedência; este é o fallback para quem monta o formulário sem passá-la.
const { canEditRegistrationSection: hasRegistrationPermission, canEditAuditSection } =
  useRegistrationPolicyPermissions()

const canEditRegistration = computed(
  () => props.canEditRegistrationSection ?? hasRegistrationPermission.value
)

/**
 * C3 — a seção "Auditoria" já está em PROD e NÃO é governada pela permissão da Q31:
 * ela só vira leitura depois de o backend recusar o salvamento com 403. Sem essa
 * separação, o deploy do web travaria para todo mundo uma tela entregue na 1.10.647.
 */
const canEditAudit = computed(() => canEditAuditSection.value)

const openActivityRecordsCount = computed(() => props.openActivityRecords ?? 0)

const acceptedActivityTypesSummary = computed(
  () =>
    `${acceptedActivityTypes.value.length} de ${SELECTABLE_ACTIVITY_TYPES.length} tipos aceitos · ` +
    'justificativa obrigatória para “Outros”.'
)

/** Aviso ② de M4: sem nenhum tipo, o hub não teria o que oferecer. */
const isActivityTypesMissing = computed(
  () => activityRecordsEnabled.value && acceptedActivityTypes.value.length === 0
)

const toggleActivityType = (type: ActivityType, checked: unknown) => {
  if (!canEditRegistration.value) return
  const next = new Set(acceptedActivityTypes.value)
  if (checked) next.add(type)
  else next.delete(type)
  acceptedActivityTypes.value = SELECTABLE_ACTIVITY_TYPES.filter((item) => next.has(item))
}

/**
 * Texto de ajuda da aprovação automática. As tolerâncias entram no texto porque são as desta
 * política: o critério central da §6.3 reusa exatamente esses dois números, e o gestor precisa
 * ver qual folga ele está autorizando.
 */
const autoApprovalCriteriaText = computed(() =>
  buildAutoApprovalCriteriaText({
    checkinLateToleranceMinutes: checkinLateToleranceMinutes.value,
    checkoutEarlyToleranceMinutes: checkoutEarlyToleranceMinutes.value
  })
)

const emptyRule = (): DSAttendancePolicyRule => ({
  name: '',
  shiftIds: [],
  recurrence: null,
  dayOfMonth: null,
  daysOfWeek: []
})

const rules = ref<DSAttendancePolicyRule[]>([emptyRule()])

/** Q18 — recorrências das regras, para o placeholder da janela da folha. */
const sheetRecurrences = computed(() =>
  rules.value
    .map((rule) => rule.recurrence)
    .filter((recurrence): recurrence is DSAttendanceRuleRecurrence => !!recurrence)
)
const templates = ref<DSAttendanceSheetTemplate[]>([])

const showRulesAndTemplates = computed(() => hasRulesAndTemplates(monitoringType.value))

const showSheetModal = ref(false)
const templateToEdit = ref<DSAttendanceSheetTemplate | null>(null)
const editingIndex = ref<number | null>(null)

watch(startDate, () => {
  if (errors.value.startDate) delete errors.value.startDate
})
watch(endDate, () => {
  if (errors.value.endDate) delete errors.value.endDate
})
watch(isIndeterminate, (val) => {
  if (val) {
    endDate.value = null
    if (errors.value.endDate) delete errors.value.endDate
  }
})

watch(monitoringType, (newType) => {
  delete errors.value.monitoringType
  delete errors.value.requiredCheckOurTeam
  delete errors.value.requiredCheckNotOurTeam
  delete errors.value.submissionDeadlineHours
  delete errors.value.deadlineCalculationType
  delete errors.value.rules
  delete errors.value.templates
  delete errors.value.externalApp
  delete errors.value.checkinLateToleranceMinutes
  delete errors.value.checkoutEarlyToleranceMinutes
  if (!hasRulesAndTemplates(newType)) {
    rules.value = [emptyRule()]
    templates.value = []
  }
  if (newType !== DSAttendanceMonitoringType.EXTERNAL_APP) {
    externalApp.value = null
  }
})

watch(requiredCheckOurTeam, (newOur) => {
  if (!newOur) {
    checkMethodOurTeam.value = null
    delete errors.value.checkMethodOurTeam
  }
})

/* -------------------------------------------------------------------------
 * M7 — herança inicial das flags da escala e aviso de desligamento
 * ------------------------------------------------------------------------- */

/** Estado com que os interruptores NASCERAM. `null` numa política já existente. */
const inheritanceBaseline = ref<ScheduleCheckFlags | null>(null)
const ourTeamTouched = ref(false)

/**
 * Etiqueta "herdado da configuração atual da escala" (balão ⑥): fica em cada
 * interruptor até a pessoa mexer nele. Ao mudar, some — fica claro o que foi
 * decisão de quem está criando a política.
 */
const isInheritedOurTeam = computed(() => !!inheritanceBaseline.value && !ourTeamTouched.value)
// Q3 — externos não herdam nada: o controle está sempre desligado.
const showInheritanceHint = computed(() => isInheritedOurTeam.value)

const onCheckToggled = (team: 'ourTeam') => {
  if (team === 'ourTeam') {
    ourTeamTouched.value = true
    delete errors.value.requiredCheckOurTeam
  }
}

/**
 * Aplica a herança. Só é chamada para política NOVA cujos interruptores ainda não
 * foram decididos por ninguém — ver `loadPolicyData`. O método nasce pré-selecionado
 * em Geolocalização quando o check nasce ligado (balão ⑦): não existe política "App
 * Minha Escala" com check ligado e sem método.
 */
const applyCheckInheritance = () => {
  const baseline = props.inheritedCheckFlags ?? SCHEDULE_DEFAULT_CHECK_FLAGS
  inheritanceBaseline.value = { ...baseline }
  ourTeamTouched.value = false
  requiredCheckOurTeam.value = baseline.ourTeam
  // Q3 — a herança da escala nunca liga o check de externos.
  requiredCheckNotOurTeam.value = false
  checkMethodNotOurTeam.value = null
  if (baseline.ourTeam) checkMethodOurTeam.value = checkMethodOurTeam.value ?? DEFAULT_CHECK_METHOD
}

/**
 * Fora da modalidade "App Minha Escala" não existe botão de check — logo, não há
 * exigência. Trocar a modalidade para Folha/App externo conta como DESLIGAR o check
 * (balão ⑧): o aviso amarelo e a confirmação valem também nesse caminho, porque o
 * efeito no médico é exatamente o mesmo — o botão some.
 */
const isAppModality = computed(
  () => monitoringType.value === DSAttendanceMonitoringType.MINHA_ESCALA_APP
)

const disablingOurTeam = computed(
  () =>
    props.currentCheckRequirement?.ourTeam === true &&
    !(isAppModality.value && requiredCheckOurTeam.value)
)
// Q3 — desligar o check de externos é decisão do produto, não da pessoa: não pede confirmação.
const needsCheckDisableConfirmation = computed(() => disablingOurTeam.value)

const disabledAudiencesText = computed(() => (disablingOurTeam.value ? 'o time interno' : ''))

/** Data que o aviso cita: a vigência do vínculo desta política (balão ⑪). */
const policyVigencyLabel = computed(() => formatVigencyDate(startDate.value))

const checkDisableConfirmed = ref(false)

const onDisableConfirmChange = (event: Event) => {
  checkDisableConfirmed.value = (event.target as HTMLInputElement).checked
}

/**
 * A confirmação vale para o que ESTAVA escrito no aviso. Observar o texto (e não só a
 * existência do aviso) cobre a troca de público sem passar por "nenhum desligamento":
 * confirmar o desligamento do time interno e, em seguida, religá-lo desligando os
 * externos não pode aproveitar a marcação anterior.
 */
watch(disabledAudiencesText, () => {
  checkDisableConfirmed.value = false
})

/** Balão ⑫ — o salvar só habilita com a caixa marcada. É a única trava nova. */
const isCheckDisableUnconfirmed = computed(
  () => needsCheckDisableConfirmation.value && !checkDisableConfirmed.value
)

const isCheckMethodMissing = computed(() => requiredCheckOurTeam.value && !checkMethodOurTeam.value)

const isEditing = computed(() => !!policyId.value)

const handleValidationError = (err: ValidationError) => {
  const errs = err.inner?.length ? err.inner : [err]
  errs.forEach((validationError) => {
    const key = validationError.path || '_general'
    errors.value[key] = validationError.message
  })
  toast.error(errs[0]?.message || 'Erro de validação. Verifique os campos.')
}

const buildPolicyData = (): DSAttendancePolicyData => ({
  id: policyId.value ? Number(policyId.value) : undefined,
  name: policyName.value,
  monitoringType: monitoringType.value,
  externalApp:
    monitoringType.value === DSAttendanceMonitoringType.EXTERNAL_APP ? externalApp.value : null,
  requiredCheckOurTeam: requiredCheckOurTeam.value,
  // Q3 — sempre desligado; o backend também força (PR2).
  requiredCheckNotOurTeam: false,
  checkMethodOurTeam: requiredCheckOurTeam.value ? checkMethodOurTeam.value : null,
  checkMethodNotOurTeam: null,
  autoPermanenceOurTeam: autoPermanenceOurTeam.value,
  autoPermanenceNotOurTeam: autoPermanenceNotOurTeam.value,
  checkinLateToleranceMinutes: checkinLateToleranceMinutes.value,
  checkoutEarlyToleranceMinutes: checkoutEarlyToleranceMinutes.value,
  submissionDeadlineHours: submissionDeadlineHours.value,
  deadlineCalculationType: deadlineCalculationType.value,
  // Sem horas, o cálculo vai `null` junto: é o que o PATCH do BE faz com `null` (§6.1).
  auditDeadlineHours: normalizeAuditDeadlineHours(auditDeadlineHours.value),
  auditDeadlineCalculationType:
    normalizeAuditDeadlineHours(auditDeadlineHours.value) === null
      ? null
      : auditDeadlineCalculationType.value,
  // Seção "Auditoria" (§6.1) — sempre enviada, mesmo nos padrões: é o que permite desligar a
  // aprovação automática de uma política que já a tinha ligada.
  sheetConferenceBy: sheetConferenceBy.value,
  autoApproval: autoApproval.value,
  // Campo limpo (`v-model.number` devolve string vazia) vale 0: "não sortear nada".
  // Desligada, a taxa vai 0: validar o campo escondido travaria o save sem erro visível.
  manualReviewSampleRate:
    autoApproval.value === DSAttendanceAutoApproval.FULL_MATCH
      ? normalizeManualReviewSampleRate(manualReviewSampleRate.value)
      : DEFAULT_MANUAL_REVIEW_SAMPLE_RATE,
  // F2 (§1.5) — sempre enviados, pelo mesmo motivo da seção "Auditoria": é o envio
  // explícito que permite DESLIGAR o que já tinha sido ligado. As listas voltam como
  // vieram (`null` continua `null`) enquanto o usuário não mexer nelas — ver
  // `acceptedActivityTypesForSave`.
  activityRecordsEnabled: activityRecordsEnabled.value,
  acceptedActivityTypes: acceptedActivityTypesForSave(),
  sourcePrecedence: sourcePrecedenceForSave(),
  // F3 (§1.5) — sempre enviados, e sem `?? default`: `null` é o valor que diz ao backend
  // "use o default do produto", e materializar o número aqui congelaria na política um
  // padrão que ainda pode mudar.
  requestAfterCheckoutHoursApp: requestAfterCheckoutHoursApp.value,
  requestAfterDaysSheet: requestAfterDaysSheet.value,
  requestAfterHoursExternal: requestAfterHoursExternal.value,
  activityRequestSendWindowHoursApp: activityRequestSendWindowHoursApp.value,
  activityRequestSendWindowDaysSheet: activityRequestSendWindowDaysSheet.value,
  // F4 (§7.2b) — só entra no payload quando o backend provou conhecer o campo.
  // Sem essa prova a chave é OMITIDA, e não mandada como `false`: um backend
  // anterior à F4 descartaria o `false` em silêncio (`ValidationPipe` com
  // `whitelist`) e a tela teria mentido que salvou.
  ...(hasPostStationGate.value
    ? { postStationBlockOnRegistration: postStationBlockOnRegistration.value }
    : {}),
  // Frente B — só com a seção na tela; o não tocado volta cru (`null` continua `null`).
  ...(hasPaymentSourceAcceptance.value
    ? {
        paymentSourceAcceptance: paymentSourceAcceptanceForSave(
          loadedPaymentSourceAcceptance.value,
          paymentSourceAcceptance.value
        )
      }
    : {}),
  links: [
    {
      startDate: startDate.value,
      endDate: isIndeterminate.value ? null : endDate.value
    }
  ],
  rules: rules.value.map((rule) => ({
    ...rule,
    shiftIds: rule.shiftIds ?? []
  })),
  templates: templates.value
})

/**
 * Desligar o Registro de Atividade com containers vivos não apaga nada: eles seguem na
 * fila. A confirmação (aviso ① de M4) existe para que ninguém desligue achando o
 * contrário. Só dispara para quem DESLIGA algo que estava ligado.
 */
const needsDisableConfirmation = computed(
  () =>
    !activityRecordsEnabled.value &&
    initialActivityRecordsEnabled.value &&
    openActivityRecordsCount.value > 0
)

const submitPolicy = async (options?: { skipDisableConfirmation?: boolean }) => {
  // M7, balão ⑫ — trava de segurança além do `:disabled` do botão: o passo 3 do criar
  // escala chama `submitPolicy` direto pelo "Avançar".
  if (isCheckDisableUnconfirmed.value) {
    toast.error('Confirme que o check-in deixa de ser exigido para salvar esta política.')
    return
  }

  if (isPaymentSourceAcceptanceIncomplete.value) {
    toast.error(
      'Selecione ao menos uma fonte aceita para cada modalidade de pagamento prioritário.'
    )
    return
  }

  if (needsDisableConfirmation.value && !options?.skipDisableConfirmation) {
    pendingDisableConfirmation.value = true
    return
  }

  pendingDisableConfirmation.value = false
  errors.value = {}
  const finalData = buildPolicyData()

  const dataToValidate = {
    ...finalData,
    startDate: finalData.links?.[0]?.startDate ?? null,
    endDate: finalData.links?.[0]?.endDate ?? null,
    isIndeterminate: isIndeterminate.value
  }

  try {
    await step3Schema.validate(dataToValidate, {
      abortEarly: false,
      context: { scheduleEndDate: props.scheduleEndDate ?? null }
    })
    emit('save', finalData)
  } catch (err: unknown) {
    if (err instanceof ValidationError) {
      handleValidationError(err)
    } else {
      // eslint-disable-next-line no-restricted-syntax -- falha local da validação yup, não erro de API
      toast.error('Erro ao salvar política de registro de plantão.')
      errors.value['_general'] = 'Ocorreu um erro ao salvar. Tente novamente.'
    }
  }
}

const confirmDisableAndSubmit = () => submitPolicy({ skipDisableConfirmation: true })

__expose({ submitPolicy, isCheckMethodMissing, isCheckDisableUnconfirmed })

const actualShifts = computed(() => {
  if (props.availableShifts && props.availableShifts.length > 0) {
    return props.availableShifts
  }
  return store.step2.shifts || []
})

const dynamicShiftOptions = computed(() => {
  return actualShifts.value.map((shift) => ({
    title: shift.title,
    value: shift.value
  }))
})

const loadLinkFields = (data: DSAttendancePolicyData) => {
  const activeLink =
    data.links?.find((link) => link.isActive) ?? data.links?.[data.links.length - 1] ?? null
  startDate.value = parseLocalDate(activeLink?.startDate)
  endDate.value = parseLocalDate(activeLink?.endDate)
  isIndeterminate.value = activeLink ? !endDate.value : false
}

const loadToleranceFields = (data: DSAttendancePolicyData) => {
  checkinLateToleranceMinutes.value = data.checkinLateToleranceMinutes ?? null
  checkoutEarlyToleranceMinutes.value = data.checkoutEarlyToleranceMinutes ?? null
  submissionDeadlineHours.value = data.submissionDeadlineHours ?? null
  deadlineCalculationType.value = data.deadlineCalculationType ?? null
  loadAuditFields(data)
}

/** Política anterior à fase 2 não tem os campos: cai nos padrões do spec, não em `null`. */
const loadAuditFields = (data: DSAttendancePolicyData) => {
  auditDeadlineHours.value = data.auditDeadlineHours ?? null
  auditDeadlineCalculationType.value = data.auditDeadlineCalculationType ?? null
  sheetConferenceBy.value = data.sheetConferenceBy ?? DEFAULT_SHEET_CONFERENCE_BY
  autoApproval.value = data.autoApproval ?? DEFAULT_AUTO_APPROVAL
  manualReviewSampleRate.value = data.manualReviewSampleRate ?? DEFAULT_MANUAL_REVIEW_SAMPLE_RATE
  loadActivityRecordFields(data)
}

/**
 * Tolerância a backend antigo (F2 ainda não existe em PROD): campos ausentes caem no
 * default do spec — `false`, os 6 tipos configuráveis e a ordem de fábrica da Q16 —,
 * nunca em `null`, para a tela não nascer num estado que o backend rejeitaria.
 */
const loadActivityRecordFields = (data: DSAttendancePolicyData) => {
  activityRecordsEnabled.value = data.activityRecordsEnabled ?? false
  initialActivityRecordsEnabled.value = activityRecordsEnabled.value
  pendingDisableConfirmation.value = false
  loadedAcceptedActivityTypes.value = data.acceptedActivityTypes ?? null
  loadedSourcePrecedence.value = data.sourcePrecedence ?? null
  acceptedActivityTypes.value = normalizeAcceptedActivityTypes(loadedAcceptedActivityTypes.value)
  sourcePrecedence.value = sanitizeSourcePrecedence(loadedSourcePrecedence.value)
  // `?? null` e nunca `|| null`: `0` (canal desligado) precisa sobreviver ao round-trip.
  requestAfterCheckoutHoursApp.value = data.requestAfterCheckoutHoursApp ?? null
  requestAfterDaysSheet.value = data.requestAfterDaysSheet ?? null
  requestAfterHoursExternal.value = data.requestAfterHoursExternal ?? null
  activityRequestSendWindowHoursApp.value = data.activityRequestSendWindowHoursApp ?? null
  activityRequestSendWindowDaysSheet.value = data.activityRequestSendWindowDaysSheet ?? null
  loadPostStationGateField(data)
  loadPaymentSourceAcceptanceField(data)
}

const loadPaymentSourceAcceptanceField = (data: DSAttendancePolicyData) => {
  const value = data.paymentSourceAcceptance
  loadedPolicyHasAcceptance.value = value !== undefined
  loadedPaymentSourceAcceptance.value = value ?? null
  paymentSourceAcceptance.value = materializePaymentSourceAcceptance(value)
}

/**
 * Sem `??` de conveniência: o campo ausente NÃO vira `false` silencioso, ele
 * apaga a seção. Fingir "desligado" para uma política que o backend nunca
 * configurou faria a tela afirmar um estado que ela não tem como saber — e o
 * backfill da F4 liga o gate justamente nas políticas existentes.
 */
const loadPostStationGateField = (data: DSAttendancePolicyData) => {
  const value = data.postStationBlockOnRegistration
  loadedPolicyHasGate.value = value !== undefined && value !== null
  postStationBlockOnRegistration.value = value === true
}

const loadMonitoringFields = (data: DSAttendancePolicyData) => {
  monitoringType.value = data.monitoringType || DSAttendanceMonitoringType.MINHA_ESCALA_APP
  externalApp.value = data.externalApp ?? null
  requiredCheckOurTeam.value = data.requiredCheckOurTeam ?? false
  // Q3 — linha antiga `true` no banco não religa o controle na tela.
  requiredCheckNotOurTeam.value = false
  checkMethodOurTeam.value = data.checkMethodOurTeam ?? null
  checkMethodNotOurTeam.value = null
  autoPermanenceOurTeam.value = data.autoPermanenceOurTeam ?? true
  autoPermanenceNotOurTeam.value = data.autoPermanenceNotOurTeam ?? true
  loadToleranceFields(data)
}

const loadRules = (data: DSAttendancePolicyData) => {
  if (data.rules?.length) {
    rules.value = data.rules.map((rule) => ({
      ...rule,
      name: rule.name ?? '',
      shiftIds: Array.isArray(rule.shiftIds) ? rule.shiftIds : [],
      daysOfWeek: Array.isArray(rule.daysOfWeek) ? rule.daysOfWeek : []
    }))
  } else {
    rules.value = [emptyRule()]
  }
}

/**
 * Política NOVA cujos interruptores ninguém decidiu ainda. `null`/`undefined` nas duas
 * flags é o que a store do criar escala e o "criar política" da aba entregam; `false`
 * explícito (usuário que já passou pelo passo 3, ou política importada) NÃO é herança.
 */
const shouldInheritScheduleCheck = (data?: DSAttendancePolicyData | null): boolean => {
  if (!data) return true
  if (data.id) return false
  return data.requiredCheckOurTeam == null && data.requiredCheckNotOurTeam == null
}

const loadPolicyData = (data?: DSAttendancePolicyData | null) => {
  const inherit = shouldInheritScheduleCheck(data)

  if (!data) {
    if (inherit) applyCheckInheritance()
    return
  }

  policyId.value = data.id ?? undefined
  policyName.value = data.name || ''
  loadLinkFields(data)
  loadMonitoringFields(data)
  loadRules(data)
  templates.value = data.templates ? JSON.parse(JSON.stringify(data.templates)) : []

  if (inherit) applyCheckInheritance()
  else inheritanceBaseline.value = null
}

watch(
  [() => props.initialData, () => props.availableShifts],
  ([newData]) => {
    loadPolicyData(newData as typeof props.initialData)
  },
  { immediate: true }
)

watch(
  () => rules.value.map((r) => r.recurrence),
  (newRecurrences) => {
    newRecurrences.forEach((recurrence, index) => {
      if (recurrence !== DSAttendanceRuleRecurrence.MONTHLY) {
        rules.value[index].dayOfMonth = null
      }
    })
  }
)

const handleHeaderSave = (val: string) => (policyName.value = val)

const addRule = () => rules.value.push(emptyRule())
const removeRule = (i: number) => rules.value.splice(i, 1)
const removeTemplate = (i: number) => templates.value.splice(i, 1)

const openNewModal = () => {
  editingIndex.value = null
  templateToEdit.value = null
  showSheetModal.value = true
}

const openEditModal = (i: number) => {
  editingIndex.value = i
  templateToEdit.value = { ...templates.value[i] }
  showSheetModal.value = true
}

const closeModal = () => {
  showSheetModal.value = false
  delete errors.value.templates
}

const handleSheetModalSave = (data: DSAttendanceSheetTemplate) => {
  if (editingIndex.value !== null) templates.value[editingIndex.value] = data
  else templates.value.push(data)
  closeModal()
}

const policySubtitle = computed(() => 'Vigência do vínculo entre escala e a política')

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'w-full flex flex-col max-h-[85vh]',
      _ctx.createSchedule ? 'gap-6' : 'gap-7',
      _ctx.fullWidthModal ? 'p-2' : 'p-6 sm:p-8'
    ])
  }, [
    (_ctx.createSchedule)
      ? (_openBlock(), _createBlock(ScheduleStepHeading, {
          key: 0,
          title: _unref(SCHEDULE_SECTION_LABELS).attendancePolicy
        }, null, 8, ["title"]))
      : (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(isEditing.value
          ? 'Editar política de registro de plantão'
          : 'Nova política de registro de plantão'), 1)),
    (!canEditRegistration.value || !canEditAudit.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(EditableHeader, {
          modelValue: policyName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((policyName).value = $event)),
          subtitle: policySubtitle.value,
          placeholder: "Nome da Política de Registro de Plantão",
          "is-initial-editing": !isEditing.value,
          "error-messages": errors.value.name,
          onSave: handleHeaderSave,
          onClearError: _cache[1] || (_cache[1] = ($event: any) => (delete errors.value.name))
        }, null, 8, ["modelValue", "subtitle", "is-initial-editing", "error-messages"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(DatePicker), {
            modelValue: startDate.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startDate).value = $event)),
            locale: "pt-BR",
            masks: { input: 'DD/MM/YYYY' },
            "max-date": _unref(scheduleMaxDate)
          }, {
            default: _withCtx(({ inputValue, inputEvents }) => [
              _createVNode(_component_v_text_field, _mergeProps({
                placeholder: "Início da vigência",
                "append-inner-icon": _unref(mdiCalendar),
                value: inputValue
              }, _toHandlers(inputEvents), {
                density: "comfortable",
                variant: "outlined",
                color: "primary20",
                class: "w-full sm:w-[192px]",
                "error-messages": errors.value.startDate
              }), null, 16, ["append-inner-icon", "value", "error-messages"])
            ]),
            _: 1
          }, 8, ["modelValue", "max-date"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(DatePicker), {
            modelValue: endDate.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endDate).value = $event)),
            locale: "pt-BR",
            masks: { input: 'DD/MM/YYYY' },
            disabled: isIndeterminate.value,
            "max-date": _unref(scheduleMaxDate)
          }, {
            default: _withCtx(({ inputValue, inputEvents }) => [
              _createVNode(_component_v_text_field, _mergeProps({
                placeholder: "Fim da vigência",
                "append-inner-icon": _unref(mdiCalendar),
                value: inputValue
              }, _toHandlers(inputEvents), {
                density: "comfortable",
                variant: "outlined",
                color: "primary20",
                class: "w-full sm:w-[192px]",
                disabled: isIndeterminate.value,
                "error-messages": errors.value.endDate
              }), null, 16, ["append-inner-icon", "value", "disabled", "error-messages"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled", "max-date"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(DsSwitch, {
            modelValue: isIndeterminate.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isIndeterminate).value = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_12
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_v_select, {
          modelValue: monitoringType.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((monitoringType).value = $event)),
          label: "Modalidade de registro",
          items: _unref(DSATTENDANCE_MONITORING_TYPE_OPTIONS),
          "item-title": "title",
          "item-value": "value",
          variant: "outlined",
          density: "comfortable",
          color: "primary20",
          class: "flex-1 min-w-[280px]",
          "error-messages": errors.value.monitoringType
        }, null, 8, ["modelValue", "items", "error-messages"]),
        (monitoringType.value === _unref(DSAttendanceMonitoringType).EXTERNAL_APP)
          ? (_openBlock(), _createBlock(_component_v_text_field, {
              key: 0,
              modelValue: externalApp.value,
              "onUpdate:modelValue": [
                _cache[6] || (_cache[6] = ($event: any) => ((externalApp).value = $event)),
                _cache[7] || (_cache[7] = ($event: any) => (delete errors.value.externalApp))
              ],
              label: "Nome do aplicativo",
              variant: "outlined",
              density: "comfortable",
              color: "primary20",
              class: "flex-1 min-w-[200px]",
              "error-messages": errors.value.externalApp
            }, null, 8, ["modelValue", "error-messages"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [
          (monitoringType.value === _unref(DSAttendanceMonitoringType).MINHA_ESCALA_APP)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, [
                  _hoisted_16,
                  (showInheritanceHint.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, " herdado da escala "))
                    : _createCommentVNode("", true)
                ]),
                (showInheritanceHint.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Começamos com o que esta escala exige hoje. Altere aqui — a partir da vigência, vale o que estiver nesta política. "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: "flex flex-col min-w-[240px] flex-1 border border-gray-200 rounded-lg px-4 py-3 opacity-70",
                    title: _unref(NOT_OUR_TEAM_CHECK_DISABLED_REASON),
                    "data-testid": "policy-check-externos-card"
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_v_checkbox, {
                        "model-value": false,
                        "data-testid": "policy-check-externos-checkbox",
                        label: "Habilitar check para externos",
                        density: "compact",
                        color: "primary",
                        "hide-details": "auto",
                        disabled: ""
                      })
                    ]),
                    _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(NOT_OUR_TEAM_CHECK_DISABLED_REASON)), 1)
                  ], 8, _hoisted_21),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_v_checkbox, {
                        modelValue: requiredCheckOurTeam.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((requiredCheckOurTeam).value = $event)),
                        "data-testid": "policy-check-nosso-time-checkbox",
                        label: "Habilitar check para nosso time",
                        density: "compact",
                        color: "primary",
                        "hide-details": "auto",
                        "error-messages": errors.value.requiredCheckOurTeam,
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (onCheckToggled('ourTeam')))
                      }, null, 8, ["modelValue", "error-messages"])
                    ]),
                    (isInheritedOurTeam.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, " ↧ herdado da configuração atual da escala "))
                      : (ourTeamTouched.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, " alterado nesta política "))
                        : _createCommentVNode("", true),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        (requiredCheckOurTeam.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createVNode(_component_v_select, {
                                modelValue: checkMethodOurTeam.value,
                                "onUpdate:modelValue": [
                                  _cache[10] || (_cache[10] = ($event: any) => ((checkMethodOurTeam).value = $event)),
                                  _cache[11] || (_cache[11] = ($event: any) => (delete errors.value.checkMethodOurTeam))
                                ],
                                "data-testid": "policy-check-nosso-time-method-select",
                                label: "Método de check",
                                items: _unref(CHECK_METHOD_OPTIONS),
                                "item-title": "title",
                                "item-value": "value",
                                variant: "outlined",
                                density: "comfortable",
                                color: "primary20",
                                hint: !checkMethodOurTeam.value ? 'Selecione o método de check' : '',
                                "persistent-hint": !checkMethodOurTeam.value,
                                "error-messages": errors.value.checkMethodOurTeam
                              }, null, 8, ["modelValue", "items", "hint", "persistent-hint", "error-messages"]),
                              (_unref(flags).enabledPermanenceRecord)
                                ? (_openBlock(), _createBlock(PermanenceToggleField, {
                                    key: 0,
                                    "model-value": autoPermanenceOurTeam.value,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (autoPermanenceOurTeam.value = $event)),
                                    "data-testid": "policy-permanence-our-team-switch"
                                  }, null, 8, ["model-value"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (monitoringType.value !== _unref(DSAttendanceMonitoringType).MINHA_ESCALA_APP)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32))
        : _createCommentVNode("", true),
      (needsCheckDisableConfirmation.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", null, [
              _createElementVNode("b", _hoisted_35, " Hoje esta escala exige check no app para " + _toDisplayString(disabledAudiencesText.value) + ". ", 1),
              _createElementVNode("span", null, [
                _createTextVNode(" Ao salvar, os médicos deixam de ver o botão de check-in "),
                (policyVigencyLabel.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" a partir de "),
                      _createElementVNode("strong", null, _toDisplayString(policyVigencyLabel.value), 1),
                      _createTextVNode(" (início da vigência desta política). ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("a partir do início da vigência desta política.")
                    ], 64)),
                _createTextVNode(" Os plantões anteriores continuam como estão. ")
              ]),
              _createElementVNode("label", _hoisted_36, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "mt-0.5 h-4 w-4 accent-primary30",
                  "data-testid": "policy-check-disable-confirm",
                  checked: checkDisableConfirmed.value,
                  onChange: onDisableConfirmChange
                }, null, 40, _hoisted_37),
                _hoisted_38
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (
          monitoringType.value !== _unref(DSAttendanceMonitoringType).EXTERNAL_APP &&
          monitoringType.value !== _unref(DSAttendanceMonitoringType).NON_DAILY_SHEET
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_v_text_field, {
                modelValue: checkinLateToleranceMinutes.value,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((checkinLateToleranceMinutes).value = $event)),
                modelModifiers: { number: true },
                label: "Tolerância de atraso",
                type: "number",
                variant: "outlined",
                density: "comfortable",
                color: "primary20",
                class: "w-full sm:w-[240px]",
                suffix: "minutos",
                "error-messages": errors.value.checkinLateToleranceMinutes,
                onInput: _cache[14] || (_cache[14] = ($event: any) => (delete errors.value.checkinLateToleranceMinutes))
              }, null, 8, ["modelValue", "error-messages"]),
              _createVNode(_component_v_text_field, {
                modelValue: checkoutEarlyToleranceMinutes.value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((checkoutEarlyToleranceMinutes).value = $event)),
                modelModifiers: { number: true },
                label: "Tolerância de saída antecipada",
                type: "number",
                variant: "outlined",
                density: "comfortable",
                color: "primary20",
                class: "w-full sm:w-[280px]",
                suffix: "minutos",
                "error-messages": errors.value.checkoutEarlyToleranceMinutes,
                onInput: _cache[16] || (_cache[16] = ($event: any) => (delete errors.value.checkoutEarlyToleranceMinutes))
              }, null, 8, ["modelValue", "error-messages"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("p", _hoisted_44, [
            _hoisted_45,
            (!canEditAudit.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_46, " 🔒 leitura "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "flex flex-col gap-5",
            inert: !canEditAudit.value || undefined
          }, [
            _createVNode(SegmentedControl, {
              modelValue: sheetConferenceBy.value,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((sheetConferenceBy).value = $event)),
              label: "Quem confere a folha contra o espelho",
              options: _unref(SHEET_CONFERENCE_BY_OPTIONS),
              help: _unref(SHEET_CONFERENCE_BY_HELP),
              "test-id-prefix": "policy-sheet-conference-by"
            }, null, 8, ["modelValue", "options", "help"]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(SegmentedControl, {
                modelValue: autoApproval.value,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((autoApproval).value = $event)),
                label: "Aprovação automática",
                options: _unref(AUTO_APPROVAL_OPTIONS),
                "test-id-prefix": "policy-auto-approval"
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("p", _hoisted_49, _toDisplayString(autoApprovalCriteriaText.value), 1)
            ]),
            _createVNode(_component_v_expand_transition, null, {
              default: _withCtx(() => [
                (autoApproval.value === _unref(DSAttendanceAutoApproval).FULL_MATCH)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createVNode(_component_v_text_field, {
                        modelValue: manualReviewSampleRate.value,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((manualReviewSampleRate).value = $event)),
                        modelModifiers: { number: true },
                        "data-testid": "policy-manual-review-sample-rate-input",
                        label: "Revisão humana por amostragem",
                        type: "number",
                        min: "0",
                        max: "100",
                        variant: "outlined",
                        density: "comfortable",
                        color: "primary20",
                        suffix: "%",
                        disabled: !canEditAudit.value,
                        "error-messages": errors.value.manualReviewSampleRate,
                        onInput: _cache[20] || (_cache[20] = ($event: any) => (delete errors.value.manualReviewSampleRate))
                      }, null, 8, ["modelValue", "disabled", "error-messages"]),
                      _createElementVNode("p", _hoisted_51, _toDisplayString(_unref(MANUAL_REVIEW_SAMPLE_RATE_HELP)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("p", _hoisted_54, _toDisplayString(_unref(AUDIT_DEADLINE_HELP)), 1),
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_component_v_text_field, {
                  modelValue: auditDeadlineHours.value,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((auditDeadlineHours).value = $event)),
                  modelModifiers: { number: true },
                  "data-testid": "policy-audit-deadline-hours-input",
                  label: "Prazo de auditoria (horas)",
                  type: "number",
                  min: "0",
                  max: "8760",
                  variant: "outlined",
                  density: "comfortable",
                  color: "primary20",
                  suffix: "horas",
                  placeholder: "Sem prazo",
                  "persistent-placeholder": "",
                  class: "min-w-[220px] flex-1",
                  disabled: !canEditAudit.value,
                  "error-messages": errors.value.auditDeadlineHours,
                  onInput: _cache[22] || (_cache[22] = ($event: any) => (delete errors.value.auditDeadlineHours))
                }, null, 8, ["modelValue", "disabled", "error-messages"]),
                _createVNode(_component_v_select, {
                  modelValue: auditDeadlineCalculationType.value,
                  "onUpdate:modelValue": [
                    _cache[23] || (_cache[23] = ($event: any) => ((auditDeadlineCalculationType).value = $event)),
                    _cache[24] || (_cache[24] = ($event: any) => (delete errors.value.auditDeadlineCalculationType))
                  ],
                  "data-testid": "policy-audit-deadline-calculation-select",
                  label: "Cálculo de horas",
                  items: _unref(DSATTENDANCE_DEADLINE_CALCULATION_OPTIONS),
                  "item-title": "title",
                  "item-value": "value",
                  variant: "outlined",
                  density: "comfortable",
                  color: "primary20",
                  class: "min-w-[220px] flex-1",
                  clearable: "",
                  disabled: !canEditAudit.value,
                  "error-messages": errors.value.auditDeadlineCalculationType
                }, null, 8, ["modelValue", "items", "disabled", "error-messages"])
              ]),
              (auditDeadlinePreview.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(auditDeadlinePreview.value), 1))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_47)
        ])
      ]),
      _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [
          (
            [
              _unref(DSAttendanceMonitoringType).FOLHA,
              _unref(DSAttendanceMonitoringType).EXTERNAL_APP,
              _unref(DSAttendanceMonitoringType).NON_DAILY_SHEET
            ].includes(monitoringType.value)
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_v_text_field, {
                    modelValue: submissionDeadlineHours.value,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((submissionDeadlineHours).value = $event)),
                    modelModifiers: { number: true },
                    label: "Limite de envio",
                    type: "number",
                    variant: "outlined",
                    density: "comfortable",
                    color: "primary20",
                    suffix: "horas",
                    "error-messages": errors.value.submissionDeadlineHours,
                    onInput: _cache[26] || (_cache[26] = ($event: any) => (delete errors.value.submissionDeadlineHours))
                  }, null, 8, ["modelValue", "error-messages"]),
                  _createVNode(_component_v_select, {
                    modelValue: deadlineCalculationType.value,
                    "onUpdate:modelValue": [
                      _cache[27] || (_cache[27] = ($event: any) => ((deadlineCalculationType).value = $event)),
                      _cache[28] || (_cache[28] = ($event: any) => (delete errors.value.deadlineCalculationType))
                    ],
                    label: "Cálculo de horas",
                    items: _unref(DSATTENDANCE_DEADLINE_CALCULATION_OPTIONS),
                    "item-title": "title",
                    "item-value": "value",
                    variant: "outlined",
                    density: "comfortable",
                    color: "primary20",
                    "error-messages": errors.value.deadlineCalculationType
                  }, null, 8, ["modelValue", "items", "error-messages"])
                ]),
                (showRulesAndTemplates.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      (
                monitoringType.value !== _unref(DSAttendanceMonitoringType).EXTERNAL_APP &&
                monitoringType.value !== _unref(DSAttendanceMonitoringType).NON_DAILY_SHEET
              )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_60,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rules.value, (rule, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "mb-8 border-b border-gray-100 pb-6 last:border-0"
                              }, [
                                _createVNode(_component_v_text_field, {
                                  modelValue: rule.name,
                                  "onUpdate:modelValue": ($event: any) => ((rule.name) = $event),
                                  label: "Nome da folha",
                                  variant: "outlined",
                                  density: "comfortable",
                                  class: "w-full",
                                  "error-messages": errors.value[`rules[${index}].name`],
                                  onInput: ($event: any) => (delete errors.value[`rules[${index}].name`])
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages", "onInput"]),
                                _createElementVNode("div", _hoisted_61, [
                                  _createVNode(_component_v_select, {
                                    modelValue: rule.shiftIds,
                                    "onUpdate:modelValue": [($event: any) => ((rule.shiftIds) = $event), ($event: any) => (delete errors.value[`rules[${index}].shiftIds`])],
                                    label: "Turnos",
                                    items: dynamicShiftOptions.value,
                                    "item-title": "title",
                                    "item-value": "value",
                                    variant: "outlined",
                                    density: "comfortable",
                                    class: "w-full sm:w-[250px]",
                                    multiple: "",
                                    chips: "",
                                    "closable-chips": "",
                                    "error-messages": errors.value[`rules[${index}].shiftIds`]
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "error-messages"]),
                                  _createVNode(_component_v_select, {
                                    modelValue: rule.recurrence,
                                    "onUpdate:modelValue": [($event: any) => ((rule.recurrence) = $event), ($event: any) => (delete errors.value[`rules[${index}].recurrence`])],
                                    label: "Recorrência",
                                    items: _unref(DSATTENDANCE_RECURRENCE_OPTIONS),
                                    "item-title": "title",
                                    "item-value": "value",
                                    variant: "outlined",
                                    density: "comfortable",
                                    class: "w-full sm:w-[150px]",
                                    "error-messages": errors.value[`rules[${index}].recurrence`]
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "error-messages"]),
                                  _createVNode(OutlinedButton, {
                                    text: "Excluir",
                                    width: "110px",
                                    height: "48px",
                                    class: "!border-negative !text-negative !bg-white",
                                    "prepend-icon": _unref(mdiTrashCanOutline),
                                    onClick: ($event: any) => (removeRule(index))
                                  }, null, 8, ["prepend-icon", "onClick"])
                                ]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: rule.dayOfMonth,
                                  "onUpdate:modelValue": ($event: any) => ((rule.dayOfMonth) = $event),
                                  modelModifiers: { number: true },
                                  label: "Dia do mês",
                                  type: "number",
                                  variant: "outlined",
                                  density: "comfortable",
                                  class: "w-full sm:w-[192px]",
                                  disabled: rule.recurrence !== _unref(DSAttendanceRuleRecurrence).MONTHLY,
                                  "error-messages": errors.value[`rules[${index}].dayOfMonth`],
                                  onInput: ($event: any) => (delete errors.value[`rules[${index}].dayOfMonth`])
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "error-messages", "onInput"]),
                                _createVNode(OptionSelect, {
                                  label: "Selecione os dias da semana",
                                  options: _unref(dayOptions),
                                  modelValue: rule.daysOfWeek,
                                  "onUpdate:modelValue": [($event: any) => ((rule.daysOfWeek) = $event), ($event: any) => (delete errors.value[`rules[${index}].daysOfWeek`])],
                                  multiple: "",
                                  "error-messages": errors.value[`rules[${index}].daysOfWeek`]
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "error-messages"])
                              ]))
                            }), 128)),
                            _createVNode(OutlinedButton, {
                              text: "Nova folha",
                              width: "140px",
                              "prepend-icon": _unref(mdiPlus),
                              onClick: addRule
                            }, null, 8, ["prepend-icon"]),
                            (errors.value.rules)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(errors.value.rules), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_63, [
                        (templates.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_64, " Modelos da folha "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value, (template, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: "flex items-center gap-4 mb-4"
                          }, [
                            _createElementVNode("div", _hoisted_65, [
                              _hoisted_66,
                              _createElementVNode("p", _hoisted_67, _toDisplayString(template.name), 1)
                            ]),
                            _createVNode(OutlinedButton, {
                              text: "Editar",
                              width: "110px",
                              "prepend-icon": _unref(mdiPencilOutline),
                              onClick: ($event: any) => (openEditModal(idx))
                            }, null, 8, ["prepend-icon", "onClick"]),
                            _createVNode(OutlinedButton, {
                              text: "Excluir",
                              width: "110px",
                              "prepend-icon": _unref(mdiTrashCanOutline),
                              class: "!border-negative !text-negative !bg-white",
                              onClick: ($event: any) => (removeTemplate(idx))
                            }, null, 8, ["prepend-icon", "onClick"])
                          ]))
                        }), 128)),
                        _createVNode(OutlinedButton, {
                          text: "Novo modelo",
                          width: "150px",
                          "prepend-icon": _unref(mdiPlus),
                          onClick: openNewModal
                        }, null, 8, ["prepend-icon"]),
                        (errors.value.templates)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(errors.value.templates), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_69, [
        _createVNode(CollapsibleSection, {
          title: "Registro de Atividade · Jornada",
          "test-id": "policy-activity-records"
        }, {
          "title-prefix": _withCtx(() => [
            (!canEditRegistration.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_70, " 🔒 leitura "))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", null, [
                _createVNode(DsSwitch, {
                  "model-value": activityRecordsEnabled.value,
                  disabled: !canEditRegistration.value,
                  "data-testid": "policy-activity-records-toggle",
                  label: "Aceitar Registro de Atividade nesta escala",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (activityRecordsEnabled.value = $event))
                }, null, 8, ["model-value", "disabled"]),
                _hoisted_72
              ]),
              _createElementVNode("div", null, [
                _hoisted_73,
                _createElementVNode("p", _hoisted_74, _toDisplayString(acceptedActivityTypesSummary.value), 1),
                _createElementVNode("div", _hoisted_75, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SELECTABLE_ACTIVITY_TYPES), (type) => {
                    return (_openBlock(), _createBlock(_component_v_checkbox, {
                      key: type,
                      "model-value": acceptedActivityTypes.value.includes(type),
                      "data-testid": `policy-activity-type-${type}`,
                      label: _unref(ACTIVITY_TYPE_LABELS)[type],
                      disabled: !canEditRegistration.value,
                      density: "compact",
                      color: "primary",
                      "hide-details": "auto",
                      "onUpdate:modelValue": ($event: any) => (toggleActivityType(type, $event))
                    }, null, 8, ["model-value", "data-testid", "label", "disabled", "onUpdate:modelValue"]))
                  }), 128))
                ]),
                (isActivityTypesMissing.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_76, " Selecione ao menos um tipo "))
                  : _createCommentVNode("", true),
                _hoisted_77
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_78, [
        _createVNode(ActivityRequestSection, {
          "monitoring-type": monitoringType.value,
          "request-after-checkout-hours-app": requestAfterCheckoutHoursApp.value,
          "request-after-days-sheet": requestAfterDaysSheet.value,
          "request-after-hours-external": requestAfterHoursExternal.value,
          "requires-app-check": requiredCheckOurTeam.value,
          "activity-records-enabled": activityRecordsEnabled.value,
          readonly: !canEditRegistration.value,
          errors: errors.value,
          "onUpdate:requestAfterCheckoutHoursApp": _cache[30] || (_cache[30] = ($event: any) => (
            setRequestDelay('requestAfterCheckoutHoursApp', $event)
          )),
          "onUpdate:requestAfterDaysSheet": _cache[31] || (_cache[31] = ($event: any) => (setRequestDelay('requestAfterDaysSheet', $event))),
          "onUpdate:requestAfterHoursExternal": _cache[32] || (_cache[32] = ($event: any) => (
            setRequestDelay('requestAfterHoursExternal', $event)
          )),
          "send-window-hours-app": activityRequestSendWindowHoursApp.value,
          "send-window-days-sheet": activityRequestSendWindowDaysSheet.value,
          "sheet-recurrences": sheetRecurrences.value,
          "onUpdate:sendWindowHoursApp": _cache[33] || (_cache[33] = ($event: any) => (
            setRequestDelay('activityRequestSendWindowHoursApp', $event)
          )),
          "onUpdate:sendWindowDaysSheet": _cache[34] || (_cache[34] = ($event: any) => (
            setRequestDelay('activityRequestSendWindowDaysSheet', $event)
          ))
        }, null, 8, ["monitoring-type", "request-after-checkout-hours-app", "request-after-days-sheet", "request-after-hours-external", "requires-app-check", "activity-records-enabled", "readonly", "errors", "send-window-hours-app", "send-window-days-sheet", "sheet-recurrences"])
      ]),
      _createElementVNode("div", _hoisted_79, [
        _createVNode(CollapsibleSection, {
          title: "Precedência das fontes (por perna)",
          "test-id": "policy-source-precedence"
        }, {
          "title-prefix": _withCtx(() => [
            (!canEditRegistration.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_80, " 🔒 leitura "))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(SourcePrecedenceList, {
              modelValue: sourcePrecedence.value,
              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((sourcePrecedence).value = $event)),
              disabled: !canEditRegistration.value
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        })
      ]),
      (hasPaymentSourceAcceptance.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
            _createVNode(CollapsibleSection, {
              title: "Fontes aceitas para Antecipe e À vista",
              "test-id": "policy-payment-source-acceptance"
            }, {
              "title-prefix": _withCtx(() => [
                (!canEditRegistration.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_82, " 🔒 leitura "))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(PaymentSourceAcceptanceMatrix, {
                  modelValue: paymentSourceAcceptance.value,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((paymentSourceAcceptance).value = $event)),
                  disabled: !canEditRegistration.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (hasPostStationGate.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
            _createVNode(CollapsibleSection, {
              title: "Pós-plantão",
              "test-id": "policy-post-station-gate"
            }, {
              "title-prefix": _withCtx(() => [
                (!canEditRegistration.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_84, " 🔒 leitura "))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", null, [
                    _createVNode(DsSwitch, {
                      "model-value": postStationBlockOnRegistration.value,
                      disabled: !canEditRegistration.value,
                      "data-testid": "policy-post-station-gate-toggle",
                      label: POST_STATION_GATE_LABEL,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (postStationBlockOnRegistration.value = $event))
                    }, null, 8, ["model-value", "disabled"]),
                    _hoisted_86
                  ]),
                  _createVNode(RegistrationBlockImpactNotice, {
                    "schedule-id": props.scheduleId ?? null,
                    from: blockImpactRange.value.from,
                    to: blockImpactRange.value.to,
                    "test-id": "policy-block-impact"
                  }, null, 8, ["schedule-id", "from", "to"]),
                  _createElementVNode("table", _hoisted_87, [
                    _hoisted_88,
                    _createElementVNode("tbody", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(POST_STATION_GATE_STATES, (state) => {
                        return _createElementVNode("tr", {
                          key: state.label,
                          class: "border-b"
                        }, [
                          _createElementVNode("td", _hoisted_89, _toDisplayString(state.label), 1),
                          _createElementVNode("td", _hoisted_90, _toDisplayString(state.meaning), 1),
                          _createElementVNode("td", _hoisted_91, _toDisplayString(state.effect), 1)
                        ])
                      }), 64))
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (errors.value._general)
        ? (_openBlock(), _createElementBlock("p", _hoisted_92, _toDisplayString(errors.value._general), 1))
        : _createCommentVNode("", true)
    ]),
    (pendingDisableConfirmation.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
          _createElementVNode("span", null, " Existem " + _toDisplayString(openActivityRecordsCount.value) + " registros em aberto; eles continuam na fila e podem ser auditados. Confirmar? ", 1),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("button", {
              type: "button",
              class: "rounded-md border border-gray-300 px-3 py-1.5 text-xs font-bold text-neutral50",
              "data-testid": "policy-activity-records-disable-cancel",
              onClick: _cache[38] || (_cache[38] = ($event: any) => (pendingDisableConfirmation.value = false))
            }, " Cancelar "),
            _createElementVNode("button", {
              type: "button",
              class: "rounded-md bg-primary30 px-3 py-1.5 text-xs font-bold text-white",
              "data-testid": "policy-activity-records-disable-accept",
              onClick: _cache[39] || (_cache[39] = ($event: any) => (confirmDisableAndSubmit()))
            }, " Confirmar ")
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.createSchedule)
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _createVNode(OutlinedButton, {
            text: "Cancelar",
            width: "140px",
            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.$emit('cancel')))
          }),
          _createVNode(FilledButton, {
            "data-testid": "policy-save",
            text: isEditing.value ? 'Salvar Alterações' : 'Criar Política',
            width: "200px",
            onClick: _cache[41] || (_cache[41] = ($event: any) => (submitPolicy())),
            loading: _unref(dsAttendanceStore).isLoadingPolicies,
            disabled: isCheckMethodMissing.value || isActivityTypesMissing.value || isCheckDisableUnconfirmed.value
          }, null, 8, ["text", "loading", "disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(SheetTemplateModal, {
      show: showSheetModal.value,
      "initial-data": templateToEdit.value,
      "monitoring-type": monitoringType.value,
      onClose: closeModal,
      onSave: handleSheetModalSave
    }, null, 8, ["show", "initial-data", "monitoring-type"])
  ], 2))
}
}

})